// src/config/loadStrings.js
export async function loadStrings() {
  const url = process.env.REACT_APP_STRINGS_URL;
  try {
    const sep = url.includes('?') ? '&' : '?';
    const res = await fetch(`${url}${sep}t=${Date.now()}`, { mode: 'cors', cache: 'no-store' });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return await res.json();
  } catch (e) {
    console.warn('[strings] remote failed, using /strings.json:', e);
    const r = await fetch('/strings.json', { cache: 'no-store' });
    return await r.json();
  }
}
